import { useEffect } from 'react'
import { useAppDispatch } from './Context'
import Sidebar from './Sidebar'
import Map from './Map'

function App({ data }) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch({ type: 'setLocations', payload: data.locations })

    document.getElementById('app').classList.add('is-init')
  }, [])

  return (
    <article className="page-wrapper">
      <div className="app-wrapper">
        <Sidebar breadcrumbs={data.breadcrumbs} headline={data.headline} content={data.content} />
        <Map apiKey={data.key} />
      </div>
    </article>
  )
}

export default App
